import Vue from "vue";
//scripts gerados a partir dos gerados pelo webChats, consultar
const lang = Vue.prototype.$lang_.getLang().title || "pt";
let imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
if (lang === "es") {
    imgSrc = require("@/assets/images/sacDesktop-es-ES.png");
} else if (lang === "en") {
    imgSrc = require("@/assets/images/sacDesktop-en-US.png");
} else {
    imgSrc = require("@/assets/images/sacDesktop-pt-BR.png");
}

const mobile = require("@/assets/images/sacMobile.png");
export const deskManager = {
    openedBy: null,

    dwhatToggle(source) {
        if (this.openedBy && this.openedBy !== source) {
            return;
        }

        const chatIcon = document.getElementById("dwhats");
        const chatWindow = document.getElementById("dwhatDiv");

        if (chatWindow == null) {
            const chatContainer = document.createElement("div");

            chatContainer.id = "dwhatDiv";
            chatContainer.style = "border-radius: 5px;position: fixed;border: 1px ridge;width: 400px;bottom: 148px;height: 500px;right: 10px;max-width: 94%; z-index: 99 !important";

            const webchat = document.createElement("div");
            webchat.id = "webchat";
            webchat.style = "width: 100%; height: 100%;";

            chatContainer.appendChild(webchat);
            document.body.appendChild(chatContainer);

            chatIcon.classList.remove("dwhatO");
            chatIcon.classList.add("dwhatC");
            this.openedBy = source;

            const token = "ibSlecNymXQ.qUszG0XSBzMatA8yujJ1dK22Tylk-o2s5-eYood21pI";

            window.WebChat.renderWebChat({
                    directLine: window.WebChat.createDirectLine({ token }),
                    locale: lang,
                    styleOptions: {
                        bubbleBackground: '#F2C230',
                        bubbleFromUserBackground: '#1374F2',
                        bubbleFromUserTextColor: 'white',

                        bubbleBorderRadius: 10,
                        bubbleFromUserBorderRadius: 10,
                    }
                },
                document.getElementById('webchat')
            );
        } else if (chatWindow.style.display === "none") {
            chatWindow.style.display = "block";
            chatIcon.classList.remove("dwhatO");
            chatIcon.classList.add("dwhatC");
            this.openedBy = source;
        } else {
            chatWindow.style.display = "none";
            chatIcon.classList.add("dwhatO");
            chatIcon.classList.remove("dwhatC");
            this.openedBy = null;
        }
    },
    dwhatLoad() {
        var e = document.createElement("style");
        (e.innerHTML = `.dwhatC::before{background:url(${imgSrc})top center no-repeat;background-size: cover;}.dwhatO::before{background:url(${imgSrc})top 
			center no-repeat;background-size: cover;}#dwhats{width:168px;height:106px;display:block;cursor: pointer;}
            @media(max-width:958px){#dwhats{width:120px;height: 120px;}.dwhatO::before{background:url(${mobile})top 
			center no-repeat;background-size: cover;}.dwhatC::before{background:url(${mobile})top center no-repeat;background-size: cover;}}
            #dwhats{position:fixed;bottom:48px;z-index:10;display:flex;align-items:center;right:15px;}
			#dwhats::before{content:\"\";width:100%;height:100%;display: block;}`),
            document.head.appendChild(e);
        let link = document.createElement("a");
        link.addEventListener("click", () => {
            this.dwhatToggle('icon');
        });
        (link.id = "dwhats"),
            (link.className = "dwhatO"),
            link.classList.add("animate__animated", "animate__fadeInUp");
        document.body.appendChild(link);
    },
};
